import { render } from "./SupplierCategoryPropertiesDialog.vue?vue&type=template&id=7e0609f5&scoped=true"
import script from "./SupplierCategoryPropertiesDialog.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryPropertiesDialog.vue?vue&type=script&lang=js"

import "./SupplierCategoryPropertiesDialog.vue?vue&type=style&index=0&id=7e0609f5&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0609f5"]])

export default __exports__